import React from 'react';
import Slide from 'react-reveal/Slide';
import styled from 'styled-components';
import Carousel from './Carousel';

const Img = styled.img`
  width: 100%;
  height: 100%;

  @media screen and (min-width: 873px) {
    margin-top: -8px !important;
  }

  @media screen and (min-width: 768px) and (max-width: 872px) {
    margin-top: 0 !important;
  }

  @media screen and (min-width: 663px) and (max-width: 767px) {
    margin-top: -16px !important;
    width: 77% !important;
  }

  @media screen and (min-width: 559px) and (max-width: 662px) {
    margin-top: -17px !important;
  }

  @media screen and (min-width: 441px) and (max-width: 558px) {
    margin-top: 0px !important;
  }

  @media screen and (min-width: 390px) and (max-width: 440px) {
    margin-top: 16px !important;
  }

  @media screen and (min-width: 320px) and (max-width: 390px) {
    margin-top: 31px !important;
  }
`;

const Slider = ({ images, imageUrl }) => (
  <Carousel defaultWait={10000000}>
    {
      Object.keys(images).map((index) => (
        <Slide right key={`${imageUrl(images[index].path)}-${index}`}>
          <Img src={imageUrl(images[index].path)} alt={`${imageUrl(images[index].path)}-${index}`} />
        </Slide>
      ))
    }
  </Carousel>
);

export default Slider;
